var map = {
	"./default/assets/AppAuthy.png": "2990",
	"./default/assets/AppGoogleAuthenticator.png": "ad61",
	"./default/assets/AppMicrosoftAuthenticator.png": "aa5b",
	"./default/assets/logo.svg": "3c3e",
	"./dls-bs/assets/favicon.ico": "1eb4",
	"./dls-bs/assets/logo.svg": "e4f2",
	"./dls-sg/assets/favicon.ico": "6db4",
	"./dls-sg/assets/logo.svg": "b32c",
	"./dls/assets/favicon.ico": "2cf1",
	"./dls/assets/logo.svg": "27ea",
	"./hf/assets/favicon.ico": "3511d",
	"./hf/assets/logo.svg": "288d",
	"./hmb/assets/logo.svg": "c388",
	"./zg/assets/favicon.ico": "864d",
	"./zg/assets/logo.svg": "ee69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e517";